<template>
    <article class="cmp cmp-product-thumb" :data-testing="item.variation.id">
        <div :class="paddingClasses" :style="paddingInlineStyles">

            <add-to-basket
                    data-testing="item-add-to-basket"
                    :variation-id="item.variation.id"
                    :is-salable="!!item.filter && item.filter.isSalable"
                    :has-children="!!item.item && item.item.salableVariationCount > 1"
                    :interval-quantity="item.variation.intervalOrderQuantity || 1"
                    :minimum-quantity="item.variation.minimumOrderQuantity"
                    :maximum-quantity="!!item.variation.maximumOrderQuantity && item.variation.maximumOrderQuantity > 0 ? item.variation.maximumOrderQuantity : null"
                    :order-properties="item.properties.filter(function(prop) { return prop.property.isOderProperty })"
                    :has-order-properties="item.hasOrderProperties"
                    :use-large-scale="true"
                    :show-quantity="false"
                    :item-url="item | itemURL(urlWithVariationId)"
                    :has-price="item | hasItemDefaultPrice"
                    :item-type="item.item.itemType">
            </add-to-basket>

            <div class="thumb-image">
                <div class="prop-1-1">
                    <slot name="item-image">
                        <category-image-carousel :image-urls-data="item.images | itemImages(imageUrlAccessor)"
                                                :alt="item | itemName"
                                                :title="item | itemName"
                                                :item-url="item | itemURL(urlWithVariationId)"
                                                :enable-carousel="$ceres.config.item.enableImageCarousel"
                                                :disable-carousel-on-mobile="disableCarouselOnMobile"
                                                ref="categoryImageCarousel">
                        </category-image-carousel>
                    </slot>
                </div>
            </div>

            <!-- STORE SPECIALS -->
            <slot name="store-special">
                <a :href="item | itemURL(urlWithVariationId)" class="special-title">
                    <item-store-special v-if="storeSpecial || item.variation.bundleType === 'bundle' || item.item.itemType === 'set'"
                                        :store-special="storeSpecial"
                                        :recommended-retail-price="item.prices.rrp"
                                        :variation-retail-price="item.prices.default"
                                        :special-offer-price="item.prices.specialOffer"
                                        :decimal-count="decimalCount"
                                        :bundle-type="item.variation.bundleType"
                                        :item-type="item.item.itemType">
                    </item-store-special>
                </a>
            </slot>
            <!-- ./STORE SPECIALS -->

            <!-- ITEM DETAILS -->
            <slot name="item-details">
                <div class="thumb-content">
                    <a :href="item | itemURL(urlWithVariationId)" class="thumb-title" :class="{ 'stretched-link': $ceres.config.global.shippingCostsCategoryId == 0 }">
                        {{ item | itemName }}<!--
                    --><span v-for="attribute in item.groupedAttributes">{{ "Ceres::Template.itemGroupedAttribute" | translate(attribute) }}</span>
                    </a>
                    <div class="thumb-meta mt-2">
                        <slot name="before-prices"></slot>

                        <div class="prices" :class="{ 'has-crossprice': item.prices.rrp && item.prices.rrp.price.value > 0 && item.prices.rrp.price.value > item.prices.default.unitPrice.value }">
                            <div class="price">
                                <template v-if="item.item.itemType === 'set'">
                                     {{ priceToFixed(item.prices.default.price.value) }}{{ currency }}
                                </template>
                                <template v-else-if="!!item.item && item.item.salableVariationCount > 1 && $ceres.isCheapestSorting" >
                                    {{ priceToFixed(item.prices.default.unitPrice.value) }}{{ currency }}
                                </template>
                                <template v-else>
                                    {{ priceToFixed(item.prices.default.unitPrice.value) }}{{ currency }}
                                </template>
                            </div>

                            <div class="reduced-price">
                                <div v-if="item.salesPrices[1] && item.salesPrices[1].price && item.prices.default.unitPrice.value > item.salesPrices[1].price" class="price-view-port">
                                    Mitgliederpreis: {{ priceToFixed(item.salesPrices[1].price) }}{{ currency }}
                                </div>
                                <div v-else-if="(item.prices.rrp && item.prices.rrp.price.value > 0 && item.prices.rrp.price.value > item.prices.default.unitPrice.value) || (item.salesPrices[1] && item.salesPrices[1].price && item.prices.default.unitPrice.value == parseFloat(item.salesPrices[1].price))" class="price-view-port">
                                    statt:
                                    <template v-if="item.prices.rrp && item.prices.rrp.price.value > 0 && item.prices.rrp.price.value > item.prices.default.unitPrice.value">
                                        {{ priceToFixed(item.prices.rrp.unitPrice.value) }}
                                    </template>
                                    <template v-else-if="item.salesPrices[1] && item.salesPrices[1].price && item.prices.default.unitPrice.value == parseFloat(item.salesPrices[1].price)">
                                        {{ priceToFixed(item.salesPrices[0].price) }}
                                    </template>
                                    <template v-else>
                                        {{ priceToFixed(item.prices.rrp.unitPrice.value) }}
                                    </template>{{ currency }}

                                </div>
                                <div v-else class="price-view-port">
                                    &nbsp;
                                </div>
                            </div>

                        </div>
                    </div>

                    <slot name="after-prices"></slot>

                    <div class="category-unit-price small" v-if="!(item.unit.unitOfMeasurement === 'C62' && item.unit.content === 1)">
                        <span>{{ item.unit.content }}</span>
                        <span>&nbsp;{{ item.unit.names.name }}</span>
                        <span v-if="item.variation.mayShowUnitPrice">&nbsp;| {{ item.prices.default.basePrice }}</span>
                    </div>

                </div>
            </slot>
            <!-- ./ITEM DETAILS  -->
        </div>
    </article>
</template>

<script>
import MonetaryFormatter from "../../helper/MonetaryFormatter";
// import { formatFloat } from "../../helper/number";
import { mapState } from "vuex";
import CategoryImageCarousel from "./CategoryImageCarousel.vue";
import ItemStoreSpecial from "./ItemStoreSpecial.vue";

export default {
    data()
    {
        return {
            currency: App.activeCurrency
        };
    },

    components: {
        CategoryImageCarousel,
        ItemStoreSpecial
    },

    props: {
        decimalCount:
        {
            type: Number,
            default: 0
        },
        imageUrlAccessor:
        {
            type: String,
            default: "urlMiddle"
        },
        itemData:
        {
            type: Object
        },
        disableCarouselOnMobile:
        {
            type: Boolean
        },
        paddingClasses:
        {
            type: String,
            default: null
        },
        paddingInlineStyles:
        {
            type: String,
            default: null
        },
        forceUrlWithVariationId:
        {
            type: Boolean,
            default: false
        }
    },

    jsonDataFields: [
        "itemDataRef"
    ],

    computed:
    {
        item()
        {
            return this.itemData || this.itemDataRef;
        },

        /**
         * returns itemData.item.storeSpecial
         */
        storeSpecial()
        {
            return this.item.item.storeSpecial;
        },

        /**
         * returns itemData.texts
         */
        texts()
        {
            return this.item.texts;
        },

        itemPrice()
        {
            return this.$options.filters.specialOffer(this.item.prices.default.unitPrice.formatted, this.item.prices, "unitPrice", "formatted" );
        },

        itemSetPrice()
        {
            return this.$options.filters.currency(
                this.item.prices.default.price.value,
                this.item.prices.default.currency
            );
        },

        urlWithVariationId()
        {
            return !this.$ceres.config.item.showPleaseSelect || this.$ceres.initialPleaseSelect == 0 || this.forceUrlWithVariationId;
        },

        ...mapState({
            showNetPrices: state => state.basket.showNetPrices
        })
    },

    methods:
    {
        priceToFixed(price)
        {
            // const decimals  = 2;
            // return parseFloat(price).toFixed(decimals).replace(".", App.decimalSeparator);

            const formatter = new MonetaryFormatter();
            return formatter.format(parseFloat(price), '');
        }
    }
}
</script>
